//////////////////////////////////////////////////////////////////////////////////////////////
// DO NOT MODIFY THIS FILE                                                                  //
// Generated by scripts/generateClientEnums.ts, which runs as part of `pnpm zen3:generate`.  //
//                                                                                          //
// Client-safe enum values. Importing these does NOT pull in zen3/schema.ts — see the        //
// generator's header comment for the bundle-size measurements that motivated this file.     //
//////////////////////////////////////////////////////////////////////////////////////////////

/* eslint-disable */

export const AiMessageRole = {
  system: "system",
  user: "user",
  assistant: "assistant",
} as const;
export type AiMessageRole = (typeof AiMessageRole)[keyof typeof AiMessageRole];

export const AiStepCostSource = {
  price: "price",
  provider: "provider",
  copied: "copied",
} as const;
export type AiStepCostSource = (typeof AiStepCostSource)[keyof typeof AiStepCostSource];

export const CoachId = {
  coach_blaze: "coach_blaze",
  dr_pragmatic: "dr_pragmatic",
  buddy_sam: "buddy_sam",
  sage_rowan: "sage_rowan",
  cora_bloom: "cora_bloom",
  theo_sage: "theo_sage",
  sergeant_knox: "sergeant_knox",
  sky_zephyr: "sky_zephyr",
  master_tao: "master_tao",
  avery_planwell: "avery_planwell",
} as const;
export type CoachId = (typeof CoachId)[keyof typeof CoachId];

export const ConnectionAuthScheme = {
  OAUTH2: "OAUTH2",
  OAUTH1: "OAUTH1",
  API_KEY: "API_KEY",
  BASIC: "BASIC",
  BILLCOM_AUTH: "BILLCOM_AUTH",
  BEARER_TOKEN: "BEARER_TOKEN",
  GOOGLE_SERVICE_ACCOUNT: "GOOGLE_SERVICE_ACCOUNT",
  NO_AUTH: "NO_AUTH",
  BASIC_WITH_JWT: "BASIC_WITH_JWT",
  CALCOM_AUTH: "CALCOM_AUTH",
  SERVICE_ACCOUNT: "SERVICE_ACCOUNT",
  SAML: "SAML",
  DCR_OAUTH: "DCR_OAUTH",
  S2S_OAUTH2: "S2S_OAUTH2",
} as const;
export type ConnectionAuthScheme = (typeof ConnectionAuthScheme)[keyof typeof ConnectionAuthScheme];

export const ConnectionOwnerScope = {
  USER: "USER",
  SPACE: "SPACE",
  SERVICE: "SERVICE",
} as const;
export type ConnectionOwnerScope = (typeof ConnectionOwnerScope)[keyof typeof ConnectionOwnerScope];

export const ConnectionStatus = {
  INITIALIZING: "INITIALIZING",
  INITIATED: "INITIATED",
  ACTIVE: "ACTIVE",
  FAILED: "FAILED",
  EXPIRED: "EXPIRED",
  INACTIVE: "INACTIVE",
  REVOKED: "REVOKED",
} as const;
export type ConnectionStatus = (typeof ConnectionStatus)[keyof typeof ConnectionStatus];

export const ConvoSpawnMode = {
  direct: "direct",
  sync: "sync",
  async: "async",
} as const;
export type ConvoSpawnMode = (typeof ConvoSpawnMode)[keyof typeof ConvoSpawnMode];

export const ConvoType = {
  chat: "chat",
  completion: "completion",
  forge: "forge",
  agent: "agent",
  analysis: "analysis",
  embedding: "embedding",
  decision: "decision",
  transcription: "transcription",
} as const;
export type ConvoType = (typeof ConvoType)[keyof typeof ConvoType];

export const ConvoVerbosity = {
  low: "low",
  medium: "medium",
  high: "high",
} as const;
export type ConvoVerbosity = (typeof ConvoVerbosity)[keyof typeof ConvoVerbosity];

export const DashboardTimePeriod = {
  today: "today",
  yesterday: "yesterday",
  sevenDayAvg: "sevenDayAvg",
  thirtyDayAvg: "thirtyDayAvg",
  todayYestSeven: "todayYestSeven",
  recent: "recent",
} as const;
export type DashboardTimePeriod = (typeof DashboardTimePeriod)[keyof typeof DashboardTimePeriod];

export const Effort = {
  trivial: "trivial",
  easy: "easy",
  medium: "medium",
  hard: "hard",
} as const;
export type Effort = (typeof Effort)[keyof typeof Effort];

export const ExecutionSignal = {
  pause: "pause",
  stop: "stop",
} as const;
export type ExecutionSignal = (typeof ExecutionSignal)[keyof typeof ExecutionSignal];

export const FeedbackType = {
  question: "question",
  feedback: "feedback",
  bug: "bug",
  request: "request",
} as const;
export type FeedbackType = (typeof FeedbackType)[keyof typeof FeedbackType];

export const Gender = {
  Male: "Male",
  Female: "Female",
  NonBinary: "NonBinary",
  Other: "Other",
  PreferNotToSay: "PreferNotToSay",
} as const;
export type Gender = (typeof Gender)[keyof typeof Gender];

export const HabitCompletedBy = {
  user: "user",
  auto: "auto",
  ai: "ai",
} as const;
export type HabitCompletedBy = (typeof HabitCompletedBy)[keyof typeof HabitCompletedBy];

export const HabitCompletion = {
  empty: "empty",
  skipped: "skipped",
  partial: "partial",
  done: "done",
} as const;
export type HabitCompletion = (typeof HabitCompletion)[keyof typeof HabitCompletion];

export const HabitEndType = {
  phase: "phase",
  program: "program",
  never: "never",
} as const;
export type HabitEndType = (typeof HabitEndType)[keyof typeof HabitEndType];

export const HabitRecurrence = {
  none: "none",
  daily: "daily",
  weekly: "weekly",
  monthly: "monthly",
  yearly: "yearly",
} as const;
export type HabitRecurrence = (typeof HabitRecurrence)[keyof typeof HabitRecurrence];

export const LabelType = {
  AUTO: "AUTO",
  FAVORITES: "FAVORITES",
  SEEDED: "SEEDED",
  CUSTOM: "CUSTOM",
} as const;
export type LabelType = (typeof LabelType)[keyof typeof LabelType];

export const LifeDomainId = {
  body: "body",
  mind: "mind",
  home: "home",
  intimacy: "intimacy",
  community: "community",
  school: "school",
  work: "work",
  business: "business",
  money: "money",
  parenting: "parenting",
  caregiving: "caregiving",
  play: "play",
  growth: "growth",
  purpose: "purpose",
  general: "general",
} as const;
export type LifeDomainId = (typeof LifeDomainId)[keyof typeof LifeDomainId];

export const McpCatalogCacheStatus = {
  ok: "ok",
  error: "error",
} as const;
export type McpCatalogCacheStatus = (typeof McpCatalogCacheStatus)[keyof typeof McpCatalogCacheStatus];

export const McpTransport = {
  stdio: "stdio",
  http: "http",
  sse: "sse",
} as const;
export type McpTransport = (typeof McpTransport)[keyof typeof McpTransport];

export const Measure = {
  mass: "mass",
  length: "length",
  volume: "volume",
  energy: "energy",
  time: "time",
  count: "count",
  ratio: "ratio",
  distance: "distance",
  scale: "scale",
  money: "money",
  sleep: "sleep",
  temp: "temp",
  tempDelta: "tempDelta",
  pressure: "pressure",
  glucose: "glucose",
} as const;
export type Measure = (typeof Measure)[keyof typeof Measure];

export const MetricBaseRule = {
  last: "last",
  highest: "highest",
  lowest: "lowest",
  average: "average",
  median: "median",
  sum: "sum",
} as const;
export type MetricBaseRule = (typeof MetricBaseRule)[keyof typeof MetricBaseRule];

export const MetricCategory = {
  body: "body",
  fitness: "fitness",
  health: "health",
  custom: "custom",
} as const;
export type MetricCategory = (typeof MetricCategory)[keyof typeof MetricCategory];

export const MetricChartType = {
  line: "line",
  bar: "bar",
  heatmap: "heatmap",
} as const;
export type MetricChartType = (typeof MetricChartType)[keyof typeof MetricChartType];

export const MetricDirection = {
  higher: "higher",
  lower: "lower",
} as const;
export type MetricDirection = (typeof MetricDirection)[keyof typeof MetricDirection];

export const OnboardingTrack = {
  specific: "specific",
  expedited: "expedited",
  comprehensive: "comprehensive",
} as const;
export type OnboardingTrack = (typeof OnboardingTrack)[keyof typeof OnboardingTrack];

export const PipelineChargeService = {
  bot: "bot",
  vercel: "vercel",
  github_actions: "github_actions",
  railway: "railway",
  neon: "neon",
} as const;
export type PipelineChargeService = (typeof PipelineChargeService)[keyof typeof PipelineChargeService];

export const PipelineHarness = {
  claude_anthropic: "claude_anthropic",
  cursor_cursor: "cursor_cursor",
  codex_railway: "codex_railway",
} as const;
export type PipelineHarness = (typeof PipelineHarness)[keyof typeof PipelineHarness];

export const PipelineRoundCause = {
  defects: "defects",
  ci: "ci",
  conflict: "conflict",
} as const;
export type PipelineRoundCause = (typeof PipelineRoundCause)[keyof typeof PipelineRoundCause];

export const PipelineStage = {
  triage: "triage",
  needs_input: "needs_input",
  planning: "planning",
  plan_review: "plan_review",
  building: "building",
  verifying: "verifying",
  in_review: "in_review",
  merging: "merging",
  done: "done",
  cancelled: "cancelled",
} as const;
export type PipelineStage = (typeof PipelineStage)[keyof typeof PipelineStage];

export const PipelineTier = {
  simple: "simple",
  standard: "standard",
  complex: "complex",
} as const;
export type PipelineTier = (typeof PipelineTier)[keyof typeof PipelineTier];

export const PipelineTurnOutcome = {
  finished: "finished",
  error: "error",
  usage_limited: "usage_limited",
} as const;
export type PipelineTurnOutcome = (typeof PipelineTurnOutcome)[keyof typeof PipelineTurnOutcome];

export const PipelineUsageStage = {
  plan: "plan",
  build: "build",
  verify: "verify",
} as const;
export type PipelineUsageStage = (typeof PipelineUsageStage)[keyof typeof PipelineUsageStage];

export const PriceType = {
  not_listed: "not_listed",
  not_available: "not_available",
  free: "free",
  once: "once",
  monthly: "monthly",
  quarterly: "quarterly",
  annual: "annual",
} as const;
export type PriceType = (typeof PriceType)[keyof typeof PriceType];

export const ProgramLessonUnlock = {
  sequential: "sequential",
  open: "open",
} as const;
export type ProgramLessonUnlock = (typeof ProgramLessonUnlock)[keyof typeof ProgramLessonUnlock];

export const ProgramLevel = {
  intro: "intro",
  beginner: "beginner",
  intermediate: "intermediate",
  advanced: "advanced",
  pro: "pro",
} as const;
export type ProgramLevel = (typeof ProgramLevel)[keyof typeof ProgramLevel];

export const ProgramMetricRole = {
  outcome: "outcome",
  behavior: "behavior",
} as const;
export type ProgramMetricRole = (typeof ProgramMetricRole)[keyof typeof ProgramMetricRole];

export const ProgramParameterType = {
  number: "number",
  choice: "choice",
  boolean: "boolean",
  text: "text",
} as const;
export type ProgramParameterType = (typeof ProgramParameterType)[keyof typeof ProgramParameterType];

export const ProgramStepType = {
  html: "html",
  md: "md",
  interview: "interview",
  youtubeUrl: "youtubeUrl",
  podcastUrl: "podcastUrl",
  podEpisode: "podEpisode",
  youtubeVideo: "youtubeVideo",
} as const;
export type ProgramStepType = (typeof ProgramStepType)[keyof typeof ProgramStepType];

export const PublishStatus = {
  draft: "draft",
  review: "review",
  approve: "approve",
  published: "published",
  rejected: "rejected",
  archived: "archived",
} as const;
export type PublishStatus = (typeof PublishStatus)[keyof typeof PublishStatus];

export const QuizQuestionType = {
  scale: "scale",
  boolean: "boolean",
  multiple_choice: "multiple_choice",
  freeform: "freeform",
} as const;
export type QuizQuestionType = (typeof QuizQuestionType)[keyof typeof QuizQuestionType];

export const QuizResultBracket = {
  Thriving: "Thriving",
  Steady: "Steady",
  Uneven: "Uneven",
  Challenged: "Challenged",
  InCrisis: "InCrisis",
} as const;
export type QuizResultBracket = (typeof QuizResultBracket)[keyof typeof QuizResultBracket];

export const QuizResultState = {
  PENDING: "PENDING",
  INITIALIZING: "INITIALIZING",
  STARTED: "STARTED",
  PAUSED: "PAUSED",
  CONTINUED: "CONTINUED",
  COMPLETED: "COMPLETED",
  SCORED: "SCORED",
} as const;
export type QuizResultState = (typeof QuizResultState)[keyof typeof QuizResultState];

export const RatingType = {
  four_thumbs: "four_thumbs",
} as const;
export type RatingType = (typeof RatingType)[keyof typeof RatingType];

export const ReasoningEffort = {
  none: "none",
  minimal: "minimal",
  low: "low",
  medium: "medium",
  high: "high",
  xhigh: "xhigh",
  max: "max",
} as const;
export type ReasoningEffort = (typeof ReasoningEffort)[keyof typeof ReasoningEffort];

export const RelationshipStatus = {
  Single: "Single",
  Married: "Married",
  Divorced: "Divorced",
  Widowed: "Widowed",
  Partnered: "Partnered",
  Other: "Other",
  PreferNotToSay: "PreferNotToSay",
} as const;
export type RelationshipStatus = (typeof RelationshipStatus)[keyof typeof RelationshipStatus];

export const RepoPackageType = {
  app: "app",
  package: "package",
} as const;
export type RepoPackageType = (typeof RepoPackageType)[keyof typeof RepoPackageType];

export const ResourceFormat = {
  hardcover: "hardcover",
  paperback: "paperback",
  kindle: "kindle",
  ebook: "ebook",
  audiobook: "audiobook",
  podcast: "podcast",
  episode: "episode",
  channel: "channel",
  video: "video",
  website: "website",
  blog: "blog",
  article: "article",
  newsletter: "newsletter",
  rss: "rss",
  other: "other",
} as const;
export type ResourceFormat = (typeof ResourceFormat)[keyof typeof ResourceFormat];

export const ResourcePlatformId = {
  amazon_us: "amazon_us",
  amazon_uk: "amazon_uk",
  amazon_ca: "amazon_ca",
  audible_us: "audible_us",
  audible_uk: "audible_uk",
  audible_ca: "audible_ca",
  goodreads: "goodreads",
  google_books: "google_books",
  open_library: "open_library",
  megaphone: "megaphone",
  podchaser: "podchaser",
  spreaker: "spreaker",
  apple_podcasts: "apple_podcasts",
  spotify_shows: "spotify_shows",
  youtube: "youtube",
  youtube_podcasts: "youtube_podcasts",
  rss: "rss",
  unknown: "unknown",
} as const;
export type ResourcePlatformId = (typeof ResourcePlatformId)[keyof typeof ResourcePlatformId];

export const RunState = {
  waiting: "waiting",
  pending: "pending",
  running: "running",
  paused: "paused",
  stopped: "stopped",
  unauth: "unauth",
  timeout: "timeout",
  hung: "hung",
  noop: "noop",
  failed: "failed",
  notfound: "notfound",
  ok: "ok",
  warning: "warning",
} as const;
export type RunState = (typeof RunState)[keyof typeof RunState];

export const SentryClassification = {
  unclassified: "unclassified",
  noise: "noise",
  transient: "transient",
  needs_fix: "needs_fix",
  dangerous: "dangerous",
} as const;
export type SentryClassification = (typeof SentryClassification)[keyof typeof SentryClassification];

export const SentryResolvedBy = {
  none: "none",
  noise: "noise",
  quiet: "quiet",
  fix: "fix",
} as const;
export type SentryResolvedBy = (typeof SentryResolvedBy)[keyof typeof SentryResolvedBy];

export const ServiceTier = {
  auto: "auto",
  flex: "flex",
  priority: "priority",
  default: "default",
  batch: "batch",
  ultrafast: "ultrafast",
} as const;
export type ServiceTier = (typeof ServiceTier)[keyof typeof ServiceTier];

export const SettingType = {
  string: "string",
  number: "number",
  boolean: "boolean",
  date: "date",
  object: "object",
} as const;
export type SettingType = (typeof SettingType)[keyof typeof SettingType];

export const SeverityLevel = {
  fatal: "fatal",
  error: "error",
  warning: "warning",
  success: "success",
  log: "log",
  info: "info",
  debug: "debug",
} as const;
export type SeverityLevel = (typeof SeverityLevel)[keyof typeof SeverityLevel];

export const SpaceUserRole = {
  USER: "USER",
  ADMIN: "ADMIN",
} as const;
export type SpaceUserRole = (typeof SpaceUserRole)[keyof typeof SpaceUserRole];

export const TaxonomyType = {
  issue: "issue",
  aspiration: "aspiration",
  practice: "practice",
} as const;
export type TaxonomyType = (typeof TaxonomyType)[keyof typeof TaxonomyType];

export const TimeBlock = {
  wakeup: "wakeup",
  morning: "morning",
  lunch: "lunch",
  afternoon: "afternoon",
  dinner: "dinner",
  evening: "evening",
  bedtime: "bedtime",
  time: "time",
} as const;
export type TimeBlock = (typeof TimeBlock)[keyof typeof TimeBlock];

export const TodoActorKind = {
  human: "human",
  agent: "agent",
} as const;
export type TodoActorKind = (typeof TodoActorKind)[keyof typeof TodoActorKind];

export const TodoState = {
  empty: "empty",
  started: "started",
  unverified: "unverified",
  blocked: "blocked",
  done: "done",
} as const;
export type TodoState = (typeof TodoState)[keyof typeof TodoState];

export const ToolAccessMode = {
  READ_ONLY: "READ_ONLY",
  READ_WRITE: "READ_WRITE",
} as const;
export type ToolAccessMode = (typeof ToolAccessMode)[keyof typeof ToolAccessMode];

export const ToolSetEntryKind = {
  mcp_server: "mcp_server",
  native_group: "native_group",
} as const;
export type ToolSetEntryKind = (typeof ToolSetEntryKind)[keyof typeof ToolSetEntryKind];

export const UnitSystem = {
  metric: "metric",
  us: "us",
  none: "none",
} as const;
export type UnitSystem = (typeof UnitSystem)[keyof typeof UnitSystem];

export const UserProgramNodeState = {
  future: "future",
  started: "started",
  completed: "completed",
  failed: "failed",
} as const;
export type UserProgramNodeState = (typeof UserProgramNodeState)[keyof typeof UserProgramNodeState];

export const UserProgramNodeType = {
  phase: "phase",
  lesson: "lesson",
  step: "step",
} as const;
export type UserProgramNodeType = (typeof UserProgramNodeType)[keyof typeof UserProgramNodeType];

export const UserProgramStatus = {
  current: "current",
  paused: "paused",
  completed: "completed",
  abandoned: "abandoned",
} as const;
export type UserProgramStatus = (typeof UserProgramStatus)[keyof typeof UserProgramStatus];

export const UserRole = {
  USER: "USER",
  ADMIN: "ADMIN",
  TEAM: "TEAM",
  AGENT: "AGENT",
} as const;
export type UserRole = (typeof UserRole)[keyof typeof UserRole];

export const Verbosity = {
  low: "low",
  medium: "medium",
  high: "high",
  auto: "auto",
} as const;
export type Verbosity = (typeof Verbosity)[keyof typeof Verbosity];
